<div class="profile-unmerge-dialog">
  <div class="title-row" mat-dialog-titled>
    <h2 mat-dialog-title>{{ "data-platform.unmerge-profile" | translate }}</h2>
    <span class="close-btn" (click)="close()" [attr.aria-label]="'generic.close' | translate"><mat-icon>close</mat-icon></span>
  </div>

  <mat-dialog-content>
    @if (result()) {
      <p data-test="unmerge-done">{{ "data-platform.unmerge-done" | translate }}</p>
      <p class="hint">{{ "data-platform.unmerge-done-delay" | translate }}</p>
    } @else if (loadFailed()) {
      <p class="error-text" data-test="unmerge-load-failed">{{ "data-platform.unmerge-load-failed" | translate }}</p>
    } @else if (!options()) {
      <mat-spinner diameter="32" class="loading-spinner"></mat-spinner>
    } @else {
      <p>{{ "data-platform.unmerge-intro" | translate }}</p>

      <div class="section-title">{{ "data-platform.identifiers" | translate }}</div>
      @for (row of identifierRows(); track row.value) {
        <mat-checkbox [checked]="row.moved" (change)="toggleIdentifier(row.value)" data-test="unmerge-identifier">
          {{ row.value }}
        </mat-checkbox>
      }

      <div class="section-title">{{ "data-platform.devices" | translate }}</div>
      @for (device of deviceRows(); track device.uid) {
        <mat-checkbox [checked]="device.moved" (change)="toggleDevice(device.uid)" data-test="unmerge-device">
          <span class="device-label">
            <span class="device-line">
              <span>UID {{ device.uid }}</span>
              @if (device.browser || device.os) {
                <span>{{ device.browser }} {{ device.os }}</span>
              }
            </span>
            <span class="device-line hint">
              @if (device.lastSeenDate) {
                <span>{{ device.lastSeenDate | formatDate }}</span>
              }
              @if (device.usedWith) {
                <span data-test="unmerge-device-used">{{ "data-platform.unmerge-device-used" | translate: { identifiers: device.usedWith } }}</span>
              }
            </span>
          </span>
        </mat-checkbox>
      }
      @if (unlistedDevices(); as counts) {
        <p class="hint" data-test="unmerge-devices-unlisted">
          {{ "data-platform.unmerge-devices-unlisted" | translate: counts }}
        </p>
      }

      <form [formGroup]="names" class="sides">
        @for (side of sides(); track side.key) {
          <section class="side" [class.side--new]="side.key === 'new'" [attr.data-test]="'unmerge-side-' + side.key">
            <div class="side-title">
              <mat-icon>{{ side.icon }}</mat-icon>
              <span>{{ side.titleKey | translate }}</span>
            </div>
            <div class="side-names">
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{ "data-platform.unmerge-first-name" | translate }}</mat-label>
                <input matInput [formControlName]="side.firstName" [attr.data-test]="'unmerge-' + side.key + '-first-name'" />
              </mat-form-field>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{ "data-platform.unmerge-last-name" | translate }}</mat-label>
                <input matInput [formControlName]="side.lastName" [attr.data-test]="'unmerge-' + side.key + '-last-name'" />
              </mat-form-field>
            </div>
            <div class="side-facts">
              @for (identifier of side.identifiers; track identifier) {
                <div class="side-fact">
                  <mat-icon fontSet="material-icons-outlined">badge</mat-icon>
                  <span class="side-fact__text" data-test="unmerge-side-identifier">{{ identifier }}</span>
                </div>
              } @empty {
                <div class="side-fact hint">
                  <mat-icon fontSet="material-icons-outlined">badge</mat-icon>
                  <span>{{ "data-platform.unmerge-side-no-identifiers" | translate }}</span>
                </div>
              }
              <div class="side-fact">
                <mat-icon fontSet="material-icons-outlined">local_offer</mat-icon>
                <span class="side-tags" data-test="unmerge-side-tags">
                  @for (tag of side.tags; track tag) {
                    <span class="tag-chip">{{ tag }}</span>
                  } @empty {
                    <span class="hint">{{ "data-platform.unmerge-side-no-tags" | translate }}</span>
                  }
                </span>
              </div>
              <div class="side-fact">
                <mat-icon>devices</mat-icon>
                <span data-test="unmerge-side-devices">{{ side.devicesKey | translate: { count: (side.devices | toLocaleNumber) } }}</span>
              </div>
            </div>
          </section>
        }
      </form>

      @if (problemKey(); as key) {
        <p class="hint" data-test="unmerge-problem">{{ key | translate }}</p>
      }
      @if (splitErrorKey(); as key) {
        <p class="error-text" data-test="unmerge-failed">{{ key | translate }}</p>
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (result(); as done) {
      @if (done.newUid) {
        <button mat-stroked-button class="secondary-button" (click)="close(done.newUid)" data-test="unmerge-open-new">
          {{ "data-platform.unmerge-open-new" | translate | uppercase }}
        </button>
      }
      <button mat-stroked-button class="primary-button" (click)="close(done.originalUid)">
        {{ "data-platform.unmerge-close-done" | translate | uppercase }}
      </button>
    } @else {
      <button mat-stroked-button class="secondary-button" [disabled]="isSplitting()" (click)="close()" data-test="unmerge-cancel">
        {{ "generic.cancel" | translate | uppercase }}
      </button>
      <button mat-stroked-button class="primary-button" [disabled]="!canUnmerge()" (click)="unmerge()" data-test="unmerge-confirm">
        @if (isSplitting()) {
          <mat-spinner diameter="18" class="button-spinner"></mat-spinner>
        } @else {
          {{ "data-platform.unmerge-confirm" | translate | uppercase }}
        }
      </button>
    }
  </mat-dialog-actions>
</div>
